'use client';

import React from 'react';

import { ForceInputPropTypes } from './ForceInput.types';

const ForceInput: React.FC<ForceInputPropTypes> = ({
  className,
  labelLines = [],
  placeholder = '',
  value,
  onChange,
}) => {
  return (
    <div
      className={`relative flex items-center rounded-lg bg-[#F8F8F8] px-[1rem] py-[1rem] text-[1.2rem] sm:px-[2rem] ${className}`}
    >
      <div className='absolute left-[56%] h-[80%] w-[0.2rem] bg-[#D9D9D9] sm:left-[42%]'></div>

      {/* Label Section */}
      <label className='block w-[85%] text-[1rem] sm:w-[46%] sm:text-[1.2rem]'>
        {labelLines.map((line, index) => (
          <p key={index} className={`${index === 0 ? 'mb-[0.5rem] font-medium' : ''}`}>
            {line}
          </p>
        ))}
      </label>

      <span className='absolute left-[60%] text-[1.2rem] font-medium text-[#C2C2C2] sm:left-[45%]'>
        {placeholder}
      </span>

      {/* Input Field */}
      <input
        type='number'
        min='0'
        step='any'
        value={value}
        onChange={onChange}
        className='[&::-webkit-inner-spin-button]:m-0 [&::-webkit-outer-spin-button]:m-0 w-[64%] bg-[#F8F8F8] text-right text-[1.6rem] font-normal outline-hidden sm:text-[2rem] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none'
        placeholder='0.0'
      />
    </div>
  );
};

export default ForceInput;
